import { useEffect } from 'react';
import { useActions, useSelector } from '../components/runtime-context';
import { getNormalizedPostSlug } from '../services/post-utils';
import { getIsPostMetadataLoaded } from '../store/is-loaded/is-loaded-selectors';
import { type NormalizedPost } from '../types';

export const useLoadedMetadataForPost = (post: NormalizedPost) => {
  const actions = useActions();
  const isMetadataLoaded = useSelector(getIsPostMetadataLoaded);

  useEffect(() => {
    const postSlug = getNormalizedPostSlug(post);

    if (!postSlug && !post.isDemo) {
      return;
    }

    if (isMetadataLoaded) {
      return;
    }

    actions.fetchPostMetadata(post);
  }, [actions, isMetadataLoaded, post]);

  return isMetadataLoaded;
};
